import { issue__EventType } from "@medbillai/generated-graphql-types";

import { awaitsActivation } from "./caseSignals";
import { type RankableAction, rankHeadlineAction } from "./headlineAction";

// Short imperative copy naming the chosen action for a blocked case (ordering is
// owned by rankHeadlineAction; this only labels the headline). Unlisted types
// fall back to the generic prompt.
const HEADLINE_ACTION_LABEL: Partial<Record<issue__EventType, string>> = {
  [issue__EventType.HIPAA_RELEASE_REQUESTED]: "Sign consent form",
  [issue__EventType.TEMPLATE_RELEASE_REQUESTED]: "Sign consent form",
  [issue__EventType.CONNECT_INSURANCE_REQUESTED]: "Connect your insurance",
  [issue__EventType.CONNECT_ACCOUNT_REQUESTED]: "Connect your account",
  [issue__EventType.DOCUMENT_UPLOADED]: "Review your documents",
  // Not imperative like its siblings: the event stays action-required from the
  // offer through to submit, and whether the user has started is `startedAt` on
  // the FaApplicationAggregate — not readable from `actions`. So neither "Apply"
  // nor "Continue" is true in both states.
  [issue__EventType.FA_FLOW]: "Discount application",
  [issue__EventType.USER_INPUT_REQUESTED]: "Answer a question",
  [issue__EventType.PAYMENT_PREFERENCES_REQUESTED]: "Set payment preferences",
  [issue__EventType.CARD_COLLECTION_REQUESTED]: "Add a card",
  [issue__EventType.PAYMENT_AGREEMENT_REQUESTED]: "Review payment agreement",
  [issue__EventType.BILL_PAY_REQUESTED]: "Review bill pay agreement",
  [issue__EventType.BILL_PAYMENT_REQUESTED]: "Pay your bill",
  [issue__EventType.CLOSURE_PAYMENT_REQUESTED]: "Make a payment",
  [issue__EventType.PAYMENT_CHARGE_FAILED]: "Update payment",
  [issue__EventType.CHAT]: "Respond to your case",
};

export const GENERIC_ACTION_LABEL = "Respond to your case";

const ACTIVATION_ACTION_LABEL = "Finish setting up your case";

/** Imperative label for a case's highest-priority required action. */
export function attentionActionLabel(caseItem: {
  actions?: readonly RankableAction[] | null;
  nateraIntake?: unknown;
  isEscalated?: boolean | null;
  labels?: readonly string[] | null;
}): string {
  if (awaitsActivation(caseItem)) {
    return ACTIVATION_ACTION_LABEL;
  }
  const { headline } = rankHeadlineAction(caseItem.actions ?? []);
  return headline
    ? (HEADLINE_ACTION_LABEL[headline.eventType] ?? GENERIC_ACTION_LABEL)
    : GENERIC_ACTION_LABEL;
}
